<template>
  <div>
    <b-col cols="12" class="my-3">
      <Search
        v-if="companyUrl"
        :allowCollapse="false"
        :url="companyUrl"
        :title="$lang.companyPerson"
        :allowFields="$lang.company_fields"
        primaryKey="company_code"
        config="person_company"
        addModalSize="lg"
        removeModalSize="xl"
        :visibleSearch="false"
        :visibleSettings="false"
        :visibleExport="false"
        :visibleFilters="false"
        :visibleViewCount="false"
        :allowEdit="false"
        :toggleable="true"
        :visibleAccordion="true"
        ref="searchCompany"
        :dynamicButtons="buttonsCompany"
        :parentPermissions="parentPermissions"
        @getPermisson="updatePermissions"
      >
        <template slot="addModal" slot-scope="search">
          <AddPersonCompany
            isModal
            @modal-end-up="search.close"
            :entityId="person_code"
            entity="person"
          />
        </template>
      </Search>
    </b-col>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_edit_company"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <EditPersonCompany
        :isModal="true"
        :companyId="company_code"
        :entityId="person_code"
        @modal-end-up="closeEditCompany"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddPersonCompany from "../person_company/addPersonCompany";
import EditPersonCompany from "../person_company/editPersonCompany";

export default {
  name: "search-person-company",
  components: {
    AddPersonCompany,
    Search,
    EditPersonCompany,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      view_edit_company: false,
      company_code: null,
      person_code: this.$route.params.code,
      companyUrl:
        this.$config.api_url +
        this.$config.resources.company_person.replace(
          "{0}",
          this.$route.params.code
        ),
      buttonsCompany: [
        {
          id: 0,
          name: "edit",
          click: this.changeCompany,
        },
        {
          id: "1",
          name: "view",
          click: this.changeCompany,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  methods: {
    changeCompany(item) {
      this.company_code = item.company_code;
      this.view_edit_company = true;
    },
    closeEditCompany() {
      this.view_edit_company = false;
      this.$refs.searchCompany.getItems();
      this.company_code = "";
    },
    updatePermissions(data) {
      this.$emit("getPermissions", data);
    },
  },
};
</script>

